import React, { Component } from 'react'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import StyleSheet from 'styles'
import Button from '@material-ui/core/Button'
import { connect } from 'react-redux'
import { CountryGroupActions } from 'actionsets'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Dependent from 'containers/shared/Dependent'
import Table, { TableHead, TableBody, TableRow, TableCell } from 'components/CollapsibleTable'

export class Show extends Component{

  constructor(props){
    super(props)
    CountryGroupActions.bindActions(this)
  }


  get objectId(){
    return this.props.match.params.id
  }

  dependsOn(){
    return Promise.all([
      this.actions.show({id: this.objectId}),
    ])
  }

  dependenciesMet(){
    return this.props.requests.filter(r => r.type === CountryGroupActions.SHOW).length === 0
  }

  renderCountryRow = ({name, continent, iso2, iso3, internet, telephone}) =>
    <TableRow>
      <TableCell>{name}</TableCell>
      <TableCell>{continent}</TableCell>
      <TableCell>{iso2}</TableCell>
      <TableCell>{iso3}</TableCell>
      <TableCell>{internet}</TableCell>
      <TableCell>{telephone}</TableCell>
    </TableRow>

  render = () =>
    <div style={{width: '100%'}}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant='h6' className={styles.headline}>Country Group: {this.props.countryGroup.name}</Typography>
        </Toolbar>
      </AppBar>
      <div className={styles.flex}>
        <Card className={styles.card}>
          <CardContent>
            <Typography variant='subtitle1' className={styles.headline}>Countries</Typography>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Continent</TableCell>
                  <TableCell>ISO2</TableCell>
                  <TableCell>ISO3</TableCell>
                  <TableCell>Internet</TableCell>
                  <TableCell>Telephone</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.props.countryGroup.countries.map(this.renderCountryRow)}
              </TableBody>
            </Table>
          </CardContent>
          <CardActions>
            <Button onClick={() => this.props.history.push('/countries')} style={{marginLeft: 'auto'}}>Close</Button>
          </CardActions>
        </Card>
      </div>
    </div>
}

const styles = StyleSheet({
  headline: {
    flex: 1
  },
  flex: {
    margin: 10,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    flex: 1,
    '@media(max-width: 500px)': {
      margin: 0
    }
  },
  wrapper: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center'
  },
  card: {
    maxWidth: 900,
    flex: 1,
    width: '100%',
    boxSizing: 'border-box'
  },
})

export default connect(({countryGroups}) => countryGroups)(Dependent({loader: true, wrapperClassName: styles.wrapper})(Show))